import React from 'react';
import Aux from './../hoc/_Aux';

export var Answer = function Answer(props) {
    var index = props.index,
        answerText = props.answerText,
        type = props.type,
        onChangehandler = props.onChangehandler;

    var elementType = type === 'single' ? 'radio' : 'checkbox';
    var elementName = type === 'single' ? 'answers-' + props.quizzId : 'answer-' + props.quizzId + '-' + index;
    var elementIdentifier = 'answer-' + props.quizzId + '-' + index;

    var checkedPreviousAnswer = typeof props.previouslyChosen !== 'undefined' && props.previouslyChosen === true ? true : false;
    var answerStatusOutput = null;
    if (props.alreadyAnswered && checkedPreviousAnswer) {

        if (typeof props.correctlyAnswered !== "undefined" && props.correctlyAnswered === true) {
            answerStatusOutput = React.createElement(
                'span',
                { className: 'tick-' + (typeof props.correctlyAnswered !== "undefined" && props.correctlyAnswered === true ? "right" : "wrong") },
                React.createElement(
                    'svg',
                    { className: 'checkmark', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50' },
                    React.createElement('path', { className: 'checkmark__check', fill: 'none', d: 'M14.1 27.2l7.1 7.2 16.7-16.8' })
                )
            );
        } else if (props.correctlyAnswered === false) {
            answerStatusOutput = React.createElement(
                'span',
                { className: 'tick-' + (typeof props.correctlyAnswered !== "undefined" && props.correctlyAnswered === true ? "right" : "wrong") },
                React.createElement(
                    'svg',
                    { className: 'cross', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 15 15' },
                    React.createElement('line', { className: 'path line', fill: 'none', x1: '0.35', y1: '0.35', x2: '11.67', y2: '11.67' }),
                    React.createElement('line', { className: 'path line', fill: 'none', x1: '0.35', y1: '11.67', x2: '11.67', y2: '0.35' })
                )
            );
        }
    }

    var content = React.createElement(
        'div',
        { className: 'answer-choice' },
        React.createElement('input', {
            type: elementType,
            name: elementName,
            id: elementIdentifier,
            onChange: onChangehandler,
            defaultChecked: checkedPreviousAnswer
        }),
        React.createElement(
            'label',
            { htmlFor: elementIdentifier },
            answerText
        ),
        answerStatusOutput
    );

    return React.createElement(
        Aux,
        null,
        content
    );
};

export default Answer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/nm-react-quiz/es/components/Quizz/Answer/Answer.js
// module id = 232
// module chunks = 0